import { render, staticRenderFns } from "./loginWindow.vue?vue&type=template&id=2fa278fe&scoped=true&"
import script from "./loginWindow.vue?vue&type=script&lang=js&"
export * from "./loginWindow.vue?vue&type=script&lang=js&"
import style0 from "./loginWindow.vue?vue&type=style&index=0&id=2fa278fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa278fe",
  null
  
)

export default component.exports